import React, {Suspense} from "react";
import Header from "../components/header";
import SimpleSlider from "../components/slider";
import Ourservices from "../components/Ourservices";
import Intro from "../components/intro";
import Footer from "../components/footer/footer";

const OurOffers = React.lazy(() => import("../components/ourOffers")) ;
const Mainproducts = React.lazy(() => import("../components/mainproducts"));


const Homepage = () => {
  return (
    <div className="bg-gray-200 relative">
    <div className="absolute w-full z-30 slide-animation">
      <Header />
    </div>
    <SimpleSlider />
    <Ourservices  />
    <Suspense>
    <Mainproducts />
    </Suspense>
    <Intro  />
    <Suspense>
    <OurOffers/>
    </Suspense>
    <Footer />
    </div>
  );
};
export default Homepage;
